import ProductContent from './ProductContent'
import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { selectedProductAtom } from '../state/selectProduct'
import { useNavigate, useParams } from 'react-router-dom'
import useProductsByRegime from '../hooks/useProductsByRegime'
import { TypeUsers } from '@/lib/enums'
import { useCurrentUser } from '@/features/auth/state/auth'
import { ROUTE_BUILDERS } from '@/config/routes'
import Spinner from '@/components/ui/spinner'

export default function ProductFlow() {
  const [selectedProduct, setSelectedProduct] = useAtom(selectedProductAtom)
  const navigate = useNavigate()
  const user = useCurrentUser()
  const { cnpjcpf = '', tenant = '' } = useParams<{ cnpjcpf: string; tenant?: string }>()
  const { data: groupedProducts = {}, isLoading } = useProductsByRegime(cnpjcpf)

  const visibleProducts = Object.values(groupedProducts).flat()

  useEffect(() => {
    if (isLoading) return

    if (!visibleProducts.length) {
      const fallbackUrl =
        user?.typeUser === TypeUsers.ADMIN && tenant
          ? ROUTE_BUILDERS.clientDashboardAdminInfo(tenant, cnpjcpf)
          : ROUTE_BUILDERS.clientDashboardInfo(cnpjcpf)

      navigate(fallbackUrl, { replace: true })
      return
    }

    const hasSelectedVisibleProduct = visibleProducts.some(product => product.id === selectedProduct?.id)
    if (!hasSelectedVisibleProduct) {
      setSelectedProduct(visibleProducts[0])
    }
  }, [cnpjcpf, isLoading, navigate, selectedProduct?.id, setSelectedProduct, tenant, user?.typeUser, visibleProducts])

  useEffect(() => {
    return () => setSelectedProduct(null)
  }, [setSelectedProduct])

  if (isLoading || (visibleProducts.length > 0 && !selectedProduct)) {
    return (
      <div className="w-full flex items-center justify-center py-10">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <>
      <ProductContent />
    </>
  )
}
